import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CreateQuarterNameConfigRequest, QuarterNameConfig, QuarterNameConfigsResponse } from "src/app/domain/models/QuarterNameConfig";
import { Routes } from "src/app/infrastructure/routes";
import { QuarterNameConfigGateway } from "../gateway/QuarterNameConfigGateway";

@Injectable({providedIn: 'root'})
export class QuarterNameConfigService extends QuarterNameConfigGateway
{
    constructor( private _http: HttpClient)
    {
        super()
    }

    create(request: CreateQuarterNameConfigRequest): Observable<QuarterNameConfig[]>
    {
      return this._http.post<QuarterNameConfig[]>(Routes.quarterNameConfigApi + '/Create', request);
    }

    update(request: CreateQuarterNameConfigRequest): Observable<QuarterNameConfig[]>
    {
      return this._http.put<QuarterNameConfig[]>(Routes.quarterNameConfigApi + '/Update', request);
    }

    getByStock(stockId: number): Observable<QuarterNameConfig[]>
    {
      return this._http.get<QuarterNameConfig[]>(Routes.quarterNameConfigApi + '/GetByStock', {params: {stockId}})
    }

    getConfigs(stockId: number): Observable<QuarterNameConfigsResponse>
    {
      return this._http.get<QuarterNameConfigsResponse>(Routes.quarterNameConfigApi + '/GetConfigs', {params: {stockId}})
    }
}
